import React from "react";
import "./AboutUsSection2.css";
import { Link, useParams } from "react-router-dom";
import AboutUsDivider from "../AboutUsDivider/AboutUsDivider";
import { useTranslation } from "react-i18next";

const AboutUsSection2 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();

  const cards = [
    {
      id: 1,
      image: require("../../../assets/aboutusimage1.png"),
      title: t("aboutUsSection2.cards.card1.title"),
      description: t("aboutUsSection2.cards.card1.description"),
      link: "/SoftwareSolutions",
    },
    {
      id: 2,
      image: require("../../../assets/Item6H.png"),
      title: t("aboutUsSection2.cards.card2.title"),
      description: t("aboutUsSection2.cards.card2.description"),
      link: "/CreativeDesign",
    },
    {
      id: 3,
      image: require("../../../assets/aboutusimage2.png"),
      title: t("aboutUsSection2.cards.card3.title"),
      description: t("aboutUsSection2.cards.card3.description"),
      link: "/AdvertisingAndMedia",
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section
      className="about-us-section2"
      aria-labelledby="services-overview-heading"
    >
      <AboutUsDivider heading={t("aboutUsSection2.divider.heading")} />
      <section className="about-virtue">
        <h2 id="services-overview-heading" className="about-title">
          {t("aboutUsSection2.title")}
        </h2>
        <div className="cards-container-aboutus">
          {cards.map((card) => (
            <article className="card-aboutus" key={card.id}>
              <figure className="card-image-aboutus">
                <img
                  src={card.image}
                  alt={card.title}
                  loading="lazy"
                  width="300"
                  height="200"
                />
                <figcaption className="card-title-aboutus">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </figcaption>
                <Link
                  to={`/${lang}${card.link}`}
                  onClick={scrollToTop}
                  aria-label={`View more about ${card.title}`}
                >
                  <button className="view-services-btn">
                    {t("aboutUsSection2.cards.button")}
                  </button>
                </Link>
              </figure>
            </article>
          ))}
        </div>
      </section>
    </section>
  );
};

export default AboutUsSection2;
